import { takeEvery, call, put, select } from "redux-saga/effects";
import { CREATE_PRODUCT, GET_PRODUCTS, REMOVE_PRODUCT, UPDATE_PRODUCT } from "store/actionTypes";
import { SetDocService, RemoveDocService } from "store/services/document";
import { GetCollectionDocs } from "store/services/collection";
import { FileUploadService, FileRemoveService } from "store/services/file";
import { message } from "antd";

// watchers
export function* GetProductsWatcher() {
  yield takeEvery(GET_PRODUCTS.WATCH, GetProductsWorker);
}
export function* CreateProductWatcher() {
  yield takeEvery(CREATE_PRODUCT.WATCH, CreateProductWorker);
}
export function* RemoveProductWatcher() {
  yield takeEvery(REMOVE_PRODUCT.WATCH, RemoveProductWorker);
}

export function* UpdateProductWatcher() {
  yield takeEvery(UPDATE_PRODUCT.WATCH, UpdateProductWorker);
}

// workers
export function* GetProductsWorker({ payload }) {
  try {
    yield put({ type: GET_PRODUCTS.LOAD });
    const response = yield call(GetCollectionDocs, payload);
    yield put({ type: GET_PRODUCTS.SUCCESS, payload: response });
  } catch (e) {
    message.error(e.message);
    yield put({ type: GET_PRODUCTS.FAIL, message: e.message });
  }
}

function* CreateProductWorker({ payload }) {
  try {
    const { ref, data, files, collection, document } = payload;
    yield put({ type: CREATE_PRODUCT.LOAD });
    const fileResponse = yield call(FileUploadService, payload);
    const updatedData = { ref, collection, document, data: { ...data, file: fileResponse[0] } };
    const response = yield call(SetDocService, updatedData);
    yield put({ type: CREATE_PRODUCT.SUCCESS, payload: updatedData });
    payload.cb && payload.cb();
    message.success("Продукт добавлен");
  } catch (e) {
    message.error(e.message);
    yield put({ type: CREATE_PRODUCT.FAIL, payload: e.message });
  }
}

function* RemoveProductWorker({ payload }) {
  try {
    yield put({ type: REMOVE_PRODUCT.LOAD });
    yield call(RemoveDocService, payload);
    yield call(FileRemoveService, { ref: payload.product.file });
    yield put({ type: REMOVE_PRODUCT.SUCCESS, payload });
    message.success("Продукт удалён");
    payload.cb && payload.cb();
  } catch (e) {
    message.error(e.message);
    yield put({ type: REMOVE_PRODUCT.FAIL, payload: e.message });
  }
}

export function* UpdateProductWorker({ payload, type }) {
  try {
    const { ref, data, files, collection, document } = payload;
    yield put({ type: UPDATE_PRODUCT.LOAD });
    const fileResponse = files[0] && files[0].url ? null : yield call(FileUploadService, payload);
    const updatedData = {
      ref,
      collection,
      document,
      data: { ...data, file: fileResponse ? fileResponse[0] : files[0].url }
    };
    yield call(SetDocService, updatedData);
    yield put({ type: UPDATE_PRODUCT.SUCCESS, payload: updatedData });
    message.success(`Продукт  ${fileResponse ? "добавлен" : "обновлён"}`);
    payload.cb && payload.cb();
  } catch (e) {
    message.error(e.message);
    yield put({ type: UPDATE_PRODUCT.FAIL });
  }
}
